const { useEffect, useState } = require('react');

const { useIndexedDB } = require('react-indexed-db-hook');

const { userApi } = require('@store');

const { useOnlineStatusDetector } = require('./useOnlineStatusDetector');

const renameFields = (arr) => {
  const defaultRename = {
    activity_id: 'activityId',
    attempt_number: 'attemptNumber',
    completed_at: 'completedAt',
    completion_type: 'completionType',
    correct_answers: 'correctAnswers',
    course_module_id: 'courseModuleId',
    lesson_id: 'lessonId',
    started_at: 'startedAt',
    test_id: 'testId',
    user_id: 'userId',
    // ...(additionalRenames || {}),
  };
  return arr.map((obj) =>
    Object.keys(obj).reduce((acc, key) => {
      if (key === 'id') return acc;
      const newKey = defaultRename[key] || key; // Use new name if it exists, otherwise keep the old name
      acc[newKey] = obj[key];
      return acc;
    }, {})
  );
};
export const useSyncOfflineData = () => {
  const { isOnline } = useOnlineStatusDetector();

  const {
    deleteRecord: deleteActivityRecord,

    getAll: getAllCompletedLessonActivities,
  } = useIndexedDB('completed_lesson_activity');

  const { deleteRecord: deleteLessonRecord, getAll: getAllCompletedLessons } =
    useIndexedDB('completed_lesson');

  const {
    deleteRecord: deleteModuleRecord,

    getAll: getAllCompletedCourseModules,
  } = useIndexedDB('completed_course_module');

  const {
    deleteRecord: deleteTestStepRecord,

    getAll: getAllCompletedTestSteps,
  } = useIndexedDB('completed_test_step');

  const { deleteRecord: deleteTestRecord, getAll: getAllCompletedTests } =
    useIndexedDB('completed_test');

  const [data, setData] = useState(null);
  const [ids, setIds] = useState(null);

  useEffect(() => {
    const init = async () => {
      const completedCourseModules = await getAllCompletedCourseModules();
      const completedLessons = await getAllCompletedLessons();
      const completedLessonActivities = await getAllCompletedLessonActivities();
      const completedTests = await getAllCompletedTests();
      const completedTestSteps = await getAllCompletedTestSteps();

      const somethingIsNotEmpty =
        completedCourseModules?.length > 0 ||
        completedLessons?.length > 0 ||
        completedLessonActivities?.length > 0 ||
        completedTests?.length > 0 ||
        completedTestSteps?.length > 0;

      if (somethingIsNotEmpty) {
        setIds({
          completedCourseModules: completedCourseModules.map((el) => el.id),
          completedLessonActivities: completedLessonActivities.map(
            (el) => el.id
          ),
          completedLessons: completedLessons.map((el) => el.id),
          completedTestSteps: completedTestSteps.map((el) => el.id),
          completedTests: completedTests.map((el) => el.id),
        });
        setData({
          completedCourseModules: renameFields(completedCourseModules).map(
            (el) => ({
              ...el,
              completedAt: el?.completedAt || null,
              completionType: el?.completionType || null,
            })
          ),
          completedLessonActivities: renameFields(
            completedLessonActivities
          ).map((el) => ({
            ...el,
            completedAt: el?.completedAt || null,
            completionType: el?.completionType || null,
          })),
          completedLessons: renameFields(completedLessons).map((el) => ({
            ...el,
            completedAt: el?.completedAt || null,
            completionType: el?.completionType || null,
          })),
          completedTestSteps: renameFields(completedTestSteps),
          completedTests: renameFields(completedTests),
        });
      }
    };
    init();
  }, []);

  const cleanTables = () => {
    ids.completedLessonActivities.forEach((id) => {
      deleteActivityRecord(id);
    });

    ids.completedLessons.forEach((id) => {
      deleteLessonRecord(id);
    });

    ids.completedCourseModules.forEach((id) => {
      deleteModuleRecord(id);
    });

    ids.completedTestSteps.forEach((id) => {
      deleteTestStepRecord(id);
    });

    ids.completedTests.forEach((id) => {
      deleteTestRecord(id);
    });

    setData(null);
  };

  const [syncProgress] = userApi.useSyncOfflineProgressMutation();

  const syncData = async () => {
    const { error } = await syncProgress(data);
    if (!error) cleanTables();
  };

  useEffect(() => {
    if (isOnline && data) {
      syncData(data);
    }
  }, [!isOnline, !data]);
};
